import styled from 'styled-components';
import {colors, devices, fonts, sizes} from "../../utils/styled/_variables.styled";
import "../../base/styled/_typograhpy.style";

const InfiosBreadcrumb = styled.section`
    display: ${props => props.overlapType === "stageL3" ? 'none' : 'flex'};
    flex-direction: row;
    /* Remove blue background when stageL3 is selected */
    background-color: ${props => (props.selector === 'blue' && props.overlapType !== 'stageL3') ? colors.blue : ''};
    width: 100%;
    margin: 0;
    position: ${props => props.isOverlaping ? 'relative' : 'static'};
    margin-top: ${props => props.isOverlaping ? '-80px' : '0'};
    z-index: ${props => props.isOverlaping ? '10' : 'auto'};

    .cmp-breadcrumb {
        width: 100%;
        padding: 17px 0;
        -webkit-mask-image: linear-gradient(270deg, transparent 16px, white 66px);
        mask-image: linear-gradient(270deg, transparent 16px, white 66px);
        max-width: ${props => props.overlapType === "stageL3" ? '870px' : '1512px'};

        margin: 0 auto;
        box-sizing: border-box;
        padding-left: 96px;
        padding-right: 96px;

        @media (min-width: 1721px) {
            width: 1512px;
            padding-left: 0px;
            padding-right: 0px;
        }

        @media (min-width: ${sizes.desktop}px) and (max-width: 1720px) {
            margin-left: 0;
            margin-right: 0;
        }

        @media ${devices.tabletLarge} {
            padding: 17px 48px;
        }

        @media ${devices.mobile} {
            padding: 17px 24px;
        }

        &__list {
            display: flex;
            gap: 16px;
            align-items: center;
        }

        &__white {
            &:first-child {
                span {
                    content: url("${props => props.iconWhite}");
                    &:hover {
                        content: url("${props => props.selector === 'blue' ? props.iconWhite : props.iconBluePressed}");
                        opacity: 0.64;
                        transition: .3s ease-in-out;
                    }
                }
            }
            li > span {
                /* Override color to black when overlapType is stageL3 and selector is blue or white */
                color: ${props =>
                    props.overlapType === 'stageL3' && (props.selector === 'blue' || props.selector === 'white')
                        ? colors.black
                        : colors.white};
            }
        }

        &__black {
            &:first-child {
                span {
                    content: url("${props => props.iconBlack}");
                    &:hover {
                        content: url("${props => props.iconBlue}");
                    }
                }
            }
        }

        &__item {
            color: ${colors.gray5};
            font-size: 14px;

            &-link {
                font-family: ${fonts.AeonikPro};
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 150%;
                color: ${colors.infiosGray};
                span {
                    transition: .3s ease-in-out;
                }

                &--white {
                    span {
                        /* Override color to black when overlapType is stageL3 and selector is blue or white */
                        color: ${props =>
                            props.overlapType === 'stageL3' && (props.selector === 'blue' || props.selector === 'white')
                                ? colors.black
                                : colors.white};
                        &:hover {
                            opacity: 0.64;
                        }
                    }
                }
                &--black {
                    span {
                        &:hover {
                            color: ${colors.blueHover};
                        }
                    }
                }
            }

            &--active {
                font-size: 14px;
                margin-right: 60px; /* this allows horizontal scroll until the end on mobile */
                span {
                    color: ${props =>
                        props.overlapType === 'stageL3' && (props.selector === 'blue' || props.selector === 'white')
                            ? colors.black
                            : (props.selector === 'blue' || props.selector === 'white' ? colors.white : colors.gray5)};
                    opacity: ${props => props.selector === 'blue' ? 0.64 : 1};
                }

                @media ${devices.mobile} {
                    margin-right: 60px; /* this allows horizontal scroll until the end on mobile */
                }
            }
            &--hidden {
                visibility: hidden;
                width: 0;
            }
        }

        &__home {
            margin-right: 16px;
            path {
                fill: ${props =>
                    props.overlapType === 'stageL3' && (props.selector === 'blue' || props.selector === 'white')
                        ? colors.black
                        : (props.colorSelector ? colors.white : colors.infiosGray)};
            }
            &:hover {
                path {
                    fill: ${props =>
                        props.overlapType === 'stageL3' && (props.selector === 'blue' || props.selector === 'white')
                            ? colors.black
                            : (props.selector === 'blue' || props.selector === 'white' ? colors.white : colors.bluePressed)};
                    opacity: ${props => props.selector === 'black' ? 1 : 0.64};
                    transition: .3s ease-in-out;
                }
            }
        }

        &__arrow {
            width: 6px;
            height: 6px;
            cursor: default;
            /* Arrow fill color: black if stageL3 selected, else white if black selector, else white default */
            svg, path {
                fill: ${props =>
                    props.overlapType === 'stageL3' && (props.selector === 'blue' || props.selector === 'white')
                        ? colors.black
                        : (props.selector === 'black' ? colors.infiosGray : colors.white)};
            }
            &--hidden {
                display: none;
            }
        }

        &__ellipsis {
            margin-top: 7px;
        }

        &__toggle {
            border: none;
            background: none;
            width: 10px;
            height: 20px;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            svg {
                path {
                    fill: ${props =>
                        props.overlapType === 'stageL3' && (props.selector === 'blue' || props.selector === 'white')
                            ? colors.black
                            : (props.selector === 'black' ? colors.infiosGray : colors.white)};
                }
            }
        }

        &__link-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 16px;

            .last__arrow {
                opacity: 0.64;

                &.--hidden {
                    visibility: hidden;
                    width: 0;
                }
            }
        }

        &__manual {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: ${colors.gray5};
            font-size: 14px;
        }

        &__link {
            align-items: center;
        }
    }

    .breadcrumbOverflow {
        overflow: auto;
        height: 48px;
        .cmp-breadcrumb__item {
            flex-shrink: 0;
        }
        @media ${devices.mobile} {
            height: 40px;
        }
    }

    .cmp-breadcrumb__white {
        &:last-child {
            opacity: 0.64;
        }
    }
`;

export { InfiosBreadcrumb };
